import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-gtja-gmoperation-plant-create-task',
  templateUrl: './gtja-gmoperation-plant-create-task.component.html',
  styleUrls: ['../parts.css']
})
export class GtjaGMOperationPlantCreateTaskComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  outSystemDataBusinessType: string;   // 业务数据
  outSystemDataBusinessId: string;
  outSystemDataBusinessVisible = false;
  outSystemDataBusinessDisplayText = '业务';
  outSystemDataBusinessData = [];
  outSystemDataCategory: string;     // 业务类别
  outSystemDataCategoryVisible = false;
  outSystemDataCategoryText = '何';
  outSystemDataCategoryData = [];
  categorieId: string; // 存放当前目录ID
  instanceData: any = {}; // 存放实例返填数据
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组';
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  backFillData: any;
  automation = {
    appId: '',
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    schedulerDescription: '',
    instanceDescription: '',
    outSystemDataBusinessType: '',
    outSystemDataCategory: '',
    taskMapping: {},
    pulseMapping: {}
  };
  appId: string;
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private message: NzMessageService,
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    if (this.appId) {
      this.getAllBusinessData(this.appId);
      this.automation.appId = this.appId;
    }
    // 处理返填数据
    // 反填分组
    this.groupConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.groupId : '';
    this.boardGroupData.forEach((item, index) => {
      if (item.id === this.groupConditionId) {
        this.groupConditionDisplayText = item.title;
      }
    });
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
      this.appId = this.automation.appId;
      this.outSystemDataBusinessId = this.appId;
      this.getAllBusinessData(this.appId);
    }
    // 带入菜单ID
    this.outSystemDataBusinessType = this.automation.outSystemDataBusinessType;
    this.outSystemDataCategory = this.automation.outSystemDataCategory;
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.packageData();
  }
  openTaskDialog() {
    if (!this.outSystemDataBusinessType) {
      this.message.create('warning', '请先选择业务！');
      return;
    }
    this.isVisible = true;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '当监听到' + this.outSystemDataBusinessDisplayText + '数据推送，类别为' + this.outSystemDataCategoryText + '时，在' + this.groupConditionDisplayText + '中创建任务';
    this.nfDataChange.emit(this.automation);
  }
  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.outSystemDataBusinessType && this.outSystemDataCategory && this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  outSystemDataBusinessChange(item) {
    this.outSystemDataBusinessDisplayText = item.businessName;
    this.outSystemDataBusinessType = item.businessType;
    this.outSystemDataBusinessId = item.id;
    this.outSystemDataBusinessVisible = false;
    this.automation.outSystemDataBusinessType = this.outSystemDataBusinessType;
    this.getBusinessCategoryData(this.outSystemDataBusinessType);
    this.packageData();
  }
  outSystemDataCategoryChange(item) {
    this.outSystemDataCategoryText = item;
    this.outSystemDataCategory = item;
    this.outSystemDataCategoryVisible = false;
    this.automation.outSystemDataCategory = this.outSystemDataCategory;
    this.packageData();
  }
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.groupConditionVisible = false;
    this.packageData();
  }
  // 根据app查询所有业务
  getAllBusinessData(appId) {
    const param = {
      system: appId
    };
    this.taskService.getAllBusiness(param).subscribe((res: any) => {
      this.outSystemDataBusinessData = res ? res : [];
      if (this.outSystemDataBusinessType) {
        this.outSystemDataBusinessData.forEach(item => {
          if (item.businessType === this.outSystemDataBusinessType) {
            this.outSystemDataBusinessDisplayText = item.businessName;
            this.getBusinessCategoryData(this.outSystemDataBusinessType);
          }
        });
      }
    });
  }
  // 查询某个业务下所有类别
  getBusinessCategoryData(businessType) {
    const param = {
      businessType: businessType
    };
    this.taskService.getBusinessCategory(param).subscribe((res: any) => {
      this.outSystemDataCategoryData = res ? res : [];
      if (this.outSystemDataCategory) {
        this.outSystemDataCategoryText = this.outSystemDataCategory;
      }
    });
  }
}
